import { HttpResponse } from '@app/lib/http/client/contracts/HttpResponse';

export class HttpException extends Error {
    public readonly response: HttpResponse | null;

    constructor(response: HttpResponse | null, error?: Error) {
        super(response != null ? HttpException.constructMessage(response) : error?.message);

        this.response = response;
    }

    private static constructMessage(response: HttpResponse) {
        return `Http request failed: ${response.status} - ${response.statusText ?? 'Unknown error'}`;
    }
}
